import { alphabeticalCompare } from 'shared'
import { InternalOrConnectionOrder } from '../components/EditOrderModal/types'
import { Internal, Connection, Item } from './types'

export function internalOrConnection(
  item: Internal | Connection
): InternalOrConnectionOrder {
  if (item.__typename === 'PayItemConnection')
    return { id: item.id, __typename: 'PayItemConnection' }
  return { id: item.internal.id, __typename: 'ProjectToInternalConnection' }
}

export function sortByOrder(a: Item, b: Item) {
  const A = `${order(a)}${name(a)}`
  const B = `${order(b)}${name(b)}`
  return alphabeticalCompare(A, B)
}

function order({ order }: Item) {
  return (order ?? 0).toString().padStart(10, '0')
}

function name(item: Item) {
  if (item.__typename === 'ProjectToInternalConnection')
    return item.internal.classType
  else if (item.__typename === 'PayItemConnection')
    return item.name ?? item.googleSheet?.title ?? item.googleSheet?.compositeId
  return item.name
}
